export const jobOpenings = [
    {
      id: 1,
      title: "HR Executive",
      location: "Calicut",
      type: "Full-time",
      experience: "1-3 years",
      department: "Human Resources",
      responsibilities: [
        "Manage recruitment processes from job posting to candidate onboarding",
        "Assist in payroll administration and employee record management",
        "Support HR compliance and policy implementation",
        "Coordinate training programs and employee engagement activities"
      ],
      requirements: [
        "Bachelor's degree in HR, Business Administration, or related field",
        "1–3 years of HR experience preferred",
        "Strong communication and organizational skills",
        "Proficiency in HR software and MS Office"
      ]
    },
    {
      id: 2,
      title: "Business Development Manager",
      location: "Calicut",
      type: "Full-time",
      experience: "3-5 years",
      department: "Business Development",
      responsibilities: [
        "Identify and develop new business opportunities in Kerala and GCC markets",
        "Build and maintain strong client relationships",
        "Collaborate with consultancy team to design customized HR solutions",
        "Achieve sales targets and contribute to company growth"
      ],
      requirements: [
        "Proven sales experience in B2B services, preferably HR or consulting",
        "Excellent negotiation and interpersonal skills",
        "Ability to work independently and as part of a team",
        "Knowledge of GCC markets is an advantage"
      ]
    },
    {
      id: 3,
      title: "Sales Manager",
      location: "Calicut", 
      type: "Full-time",
      experience: "2-4 years",
      department: "Sales",
      responsibilities: [
        "Manage client accounts and generate new business leads in India and GCC region",
        "Present and promote company services to potential clients",
        "Coordinate with project team to deliver client solutions",
        "Maintain CRM and sales reporting"
      ],
      requirements: [
        "Experience in sales or business development in Indian markets",
        "Knowledge of HR consultancy services is an advantage",
        "Strong communication and client management skills",
        "Proven track record of meeting sales targets"
      ]
    }
  ];